import { graphql } from 'react-relay'

export const updateUserPreference = graphql`
  mutation updateUserPreferenceMutation($input: StoreUserPreferenceInput!) {
    storeUserPreference(input: $input) {
      preference {
        key
        value
        valueJson
      }
    }
  }
`